<template>
  <div
    class="tw:px-3 tw:py-2 tw:border-t tw:border-default-200 tw:flex tw:flex-row tw:items-center tw:gap-4 tw:justify-end"
  >
    <KeyboardShortcut :keys="['Esc']" :text="trans._menu.searchBar.toClose" />
  </div>
</template>

<script setup lang="ts">
import KeyboardShortcut from "./KeyboardShortcut.vue";
</script>
